
import { twMerge } from 'tailwind-merge'
import { clsx, type ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}
export const cnx = (...inputs: ClassValue[]) => clsx(...inputs)

export const areArraysEqual = (a: string[], b: string[]): boolean => {
	return a.every(e => b.includes(e)) && b.every(e => a.includes(e))
}

export const uuid = (length: number = 6) => {
	return parseInt(
		Math.ceil(Math.random() * Date.now())
			.toPrecision(length)
			.toString()
			.replace('.', '')
	)
}


export function dataJson(data: any): any {
	return JSON.parse(JSON.stringify(data))
}


export function domainParse(url: string) {
	const urlParts = new URL(url).hostname.split('.')
	const sliceIndex = urlParts.length === 4 ? 3 : 2
	return urlParts.slice(-sliceIndex).join('.')
}



export function truncate(str: string, length: number) {
	return str.length > length ? `${str.substring(0, length)}...` : str
}
export function toSentenceCase(str: string) {
	return str.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
}

export function toTitleCase(str: string): string {
	return str.replace(/\w\S*/g, (txt: string) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())
}
